module.exports = __webpack_public_path__ + "img/pic_empty_404@2x.e076ec44.png";